import { BenefitIcon } from '@/common/components/BenefitIcon/BenefitIcon';
import { BudgetIcon } from '@/common/components/BudgetIcon/BudgetIcon';
import { Icon } from '@/common/components/Icons/Icon';
import { MenhirBudgetLogos } from '@/common/integrations/menhir/employee/budgets/budgets.types';
import { IMovement } from '@/common/integrations/menhir/employee/movements/movements.types';
import {
  IBadgeIconType,
  IBenefitType,
  IPocketType,
} from '@/common/types/general';
import { benefitTypeSlugMapping } from '@/common/utils/benefits';
import { budgetTopupTypes } from '@/web/containers/Budgets/util';

interface IProps {
  type: IBadgeIconType;
  subcategory?: IMovement['subcategory'];
  pocketType?: IPocketType;
  budgetLogo?: MenhirBudgetLogos;
  isDebit?: boolean;
}

const isBenefitType = (type: IBadgeIconType): type is IBenefitType =>
  Object.keys(benefitTypeSlugMapping).includes(type);

export const MovementIcon = ({
  type,
  subcategory,
  pocketType,
  budgetLogo,
  isDebit,
}: IProps) => {
  let icon = null;

  if (pocketType === 'budget' && subcategory === 'ewa_request') {
    return <Icon icon="money-bill-trend-up" color="accentSecondary10" />;
  } else if (
    pocketType === 'budget' &&
    !budgetTopupTypes.includes(subcategory)
  ) {
    return budgetLogo ? (
      <BudgetIcon type={budgetLogo} color="accentSecondary10" />
    ) : null;
  } else if (isBenefitType(type)) {
    return <BenefitIcon benefit={benefitTypeSlugMapping[type]} />;
  } else {
    switch (type) {
      case 'top_up':
        icon = <Icon icon="sack" color="systemSuccess" />;
        break;
      case 'transfer':
        icon = (
          <Icon
            icon="right-left"
            color={isDebit ? 'accentSecondary10' : 'systemSuccess'}
          />
        );
        break;
      case 'employee_to_company':
        icon = <Icon icon="right-left" color="accentSecondary10" />;
        break;
      case 'health':
        icon = <Icon icon="shield-plus" color="accentSecondary10" />;
        break;
    }
  }
  return icon;
};
